/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { MarketplaceDTOFromJSON, UserMarketplaceCreateDTOToJSON, UserMarketplaceResponseDTOFromJSON, } from '../models/index';
/**
 *
 */
export class UserMarketplaceControllerApi extends runtime.BaseAPI {
    /**
     */
    async addActiveRaw(requestParameters, initOverrides) {
        if (requestParameters['userMarketplaceCreateDTO'] == null) {
            throw new runtime.RequiredError('userMarketplaceCreateDTO', 'Required parameter "userMarketplaceCreateDTO" was null or undefined when calling addActive().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/marketplace/active`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserMarketplaceCreateDTOToJSON(requestParameters['userMarketplaceCreateDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => UserMarketplaceResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async addActive(requestParameters, initOverrides) {
        const response = await this.addActiveRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getActiveRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/marketplace/active`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserMarketplaceResponseDTOFromJSON));
    }
    /**
     */
    async getActive(initOverrides) {
        const response = await this.getActiveRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getAvailableRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/marketplace/available`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MarketplaceDTOFromJSON));
    }
    /**
     */
    async getAvailable(initOverrides) {
        const response = await this.getAvailableRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async removeActiveRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling removeActive().');
        }
        const queryParameters = {};
        if (requestParameters['marketplace'] != null) {
            queryParameters['marketplace'] = requestParameters['marketplace'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/marketplace/active`;
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async removeActive(requestParameters, initOverrides) {
        await this.removeActiveRaw(requestParameters, initOverrides);
    }
}
/**
 * @export
 */
export const RemoveActiveMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
